import actions from '@legacy/helpers/constants/actions';
import alertTypes from "@legacy/helpers/constants/alertTypes";
import companyFilterContexts from "@legacy/helpers/constants/companyFilterContexts";
import counts, {rightsRequestsCounts} from "@legacy/helpers/utils/countsDefaults";
import currencyLabels from "@legacy/helpers/constants/currencyLabels";
import icons from "@legacy/helpers/constants/icons";
import keys from "@legacy/helpers/constants/keyboard";
import pageSizes from "@legacy/helpers/constants/pageSizes";
import productDurations from "@legacy/helpers/constants/productDurations";
import productFormats from "@legacy/helpers/constants/productFormats";
import refreshTypes from "@legacy/helpers/constants/refreshTypes";
import resourceDefaults from "@legacy/helpers/utils/resourceDefaults";
import scopeTypes from "@legacy/helpers/constants/scopeTypes";
import statuses, {statusesText, rightsRequestsStatusesText} from "@legacy/helpers/constants/statuses";

export default {
    action: actions,
    alertType: alertTypes,
    count: counts,
    currencyLabel: currencyLabels,
    duration: productDurations,
    filterContext: companyFilterContexts,
    format: productFormats,
    icon: icons,
    key: keys,
    pageSizes: pageSizes,
    refreshType: refreshTypes,
    resource: resourceDefaults,
    scopeType: scopeTypes,
    status: statuses,
    statusText: statusesText,
    requestCount: rightsRequestsCounts,
    requests_statusText: rightsRequestsStatusesText
}